import { useMemo } from 'react';
import type { ICreateUpdateContactUsFeatureDto } from '@canvas-logic/clp-api-types';
import { useDisplayContext, useTranslator } from '@canvas-logic/clp-shared-ui';

/**
 * Resolve per-field contact-form labels (ADR-0045). For each configured
 * field, probes the `ui.requestQuote.field.<name>` canonical through the UI
 * cascade and returns only fields whose value came from a PAYLOAD layer —
 * fields without a project translation are omitted so `RequestQuoteForm`
 * falls back to its bundled i18next `form.request-quote.label.*` catalog.
 */
export function useContactFormFieldLabels(schema: ICreateUpdateContactUsFeatureDto | null): Record<string, string> {
  const translator = useTranslator();
  const ctx = useDisplayContext();

  return useMemo(() => {
    const out: Record<string, string> = {};
    const groups = schema?.configuration.fieldGroups ?? [];
    for (const group of groups) {
      for (const field of group.fields) {
        const hit = translator.uiWithSource(`ui.requestQuote.field.${field.name}`, ctx);
        if (hit.layer === 'selected' || hit.layer === 'default' || hit.layer === 'system') out[field.name] = hit.value;
      }
    }
    return out;
  }, [schema, translator, ctx]);
}
